import React from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import style from './style.module.css';
import Modal from 'react-modal';

@inject(store => {
    const { myShopApiStore, ifaceMngr } = store;
    return { myShopApiStore, ifaceMngr };
})
@observer
class NoInternetModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isChecking: false
        };
        
        this.checkInterval = null;
        this.modalStyle = {
            content : {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '20px',
                width: '365px',
                overflow: 'hidden',
                padding: '20px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                border: 'none'
            },
            overlay: {
                backgroundColor: "rgb(0, 0, 0, 0.75)",
                zIndex: 9999
            }
        }
    }

    checkConnection = async () => {
        if (!this.props.modalIsOpen || this.state.isChecking) return;
        
        try {
            this.setState({ isChecking: true });
            
            const apiUrl = process.env.REACT_APP_MY_SHOP_URL;
            const healthCheckUrl = `${apiUrl}/api/health-check`;
            
            const response = await fetch(healthCheckUrl, {
                method: 'GET',
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            if (response.ok) {
                this.props.myShopApiStore.isOnline = true;
                this.clearCheckInterval();
                window.location.href = '/';
                setTimeout(() => {
                    window.location.href = '/';
                    window.location.reload();
                }, 100);
            } else {
                throw new Error('API Health check failed');
            }
        } catch (error) {
            console.error('Connection check failed:', error);
            this.props.myShopApiStore.isOnline = false;
        } finally {
            if (this.props.modalIsOpen) {
                this.setState({ isChecking: false });
            }
        }
    }

    startCheckInterval = () => {
        if (!this.checkInterval) {
            this.checkInterval = setInterval(this.checkConnection, 5000);
        }
    }

    clearCheckInterval = () => {
        if (this.checkInterval) {
            clearInterval(this.checkInterval);
            
            this.setState({apiLoaderIsOpen: false});
            this.setState(prevState => ({ ...prevState, apiLoaderIsOpen: false }))
            this.checkInterval = null;
        }
    }

    componentDidMount() {
        if (this.props.modalIsOpen) {
            this.checkConnection();
            this.startCheckInterval();
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.modalIsOpen && this.props.modalIsOpen) {
            this.checkConnection();
            this.startCheckInterval();
        }
        else if (prevProps.modalIsOpen && !this.props.modalIsOpen) {
            this.clearCheckInterval();
        }
    }

    componentWillUnmount() {
        this.clearCheckInterval();
    }

    handleTryAgain = () => {
        this.checkConnection();
    }

    render() {
        const { modalIsOpen, closeModal, t } = this.props;
        const { isOnline } = this.props.myShopApiStore;
        const { isChecking } = this.state;

        return (
            <Modal 
                style={this.modalStyle} 
                isOpen={modalIsOpen} 
                
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEsc={false}
            >
                <div className={style.Container}>
                    {/* <div className={style.CloseBtn} onClick={closeModal}>✕</div> */}
                    <div className={style.Icon}>
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 4C7.31 4 3.07 5.9 0 8.98L12 21L24 8.98C20.93 5.9 16.69 4 12 4ZM2.92 9.07C5.51 7.08 8.67 6 12 6C15.33 6 18.49 7.08 21.08 9.07L12 18.17L2.92 9.07Z" fill="#ff3b3b"/>
                        </svg>
                    </div>
                    <div className={style.TextContent}>
                        <div className={style.Title}>
                            <span>{t('No internet connection')}</span>
                        </div>
                        <div className={style.Message}>
                            <span>
                                {isChecking 
                                    ? t('Checking connection...') 
                                    : (isOnline 
                                        ? t('Trying to reconnect...') 
                                        : t('Please check your internet connection and try again'))}
                            </span>
                        </div>
                    </div>
                    <div 
                        className={`${style.TryAgainBtn} ${isChecking ? style.Disabled : ''}`} 
                        onClick={!isChecking ? this.handleTryAgain : undefined}
                    >
                        <span>{isChecking ? t('Checking...') : t('Try again')}</span>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default withTranslation()(NoInternetModal);